import { useEffect, useRef, useState } from "react";
import { getMatchTimeLeft } from "./getMatchTimeLeft";
import { storeSync } from "./storeSync";

export function useMatchTimeLeft(): number {
  const latestBlockTimestamp = useRef(0n);

  useEffect(() => {
    const subscription = storeSync.latestBlock$.subscribe((block) => (latestBlockTimestamp.current = block.timestamp));
    return () => subscription.unsubscribe();
  }, []);

  const [timeLeft, setTimeLeft] = useState(getMatchTimeLeft(latestBlockTimestamp.current));

  useEffect(() => {
    const timer = setInterval(
      () => requestIdleCallback(() => setTimeLeft(getMatchTimeLeft(latestBlockTimestamp.current)), { timeout: 1000 }),
      1000,
    );
    return () => clearTimeout(timer);
  }, [setTimeLeft]);

  return timeLeft;
}
